export default __webpack_public_path__ + "static/media/welfare.c4dbc8a4.svg";